import { exploreByIndicatorsSlice } from '@Store/slices/exploreByIndicators';

export const { setActiveViewBy, setActiveViewAs, setSelectedIndicator } =
  exploreByIndicatorsSlice.actions;
